<template>
    <transition name="fade" mode="out-in">
        <section class="padding-vertical-content lightgray-content mb-3 mb-lg-4" key="paso1" id="paso1">
            <div class="container">
                <div class="row">
                    <b-col cols="12">
                        <h2 class="h1 text-uppercase">{{ $t('nuevo_abono.completa_datos') }}</h2>
                        <div class="subtitle h3 light mb-3">{{ $t('nuevo_abono.completa_info', {abono: teatro.texto_abono}) }}</div>
                    </b-col>
                    <div class="col-12">
                        <ValidationObserver tag="form" ref="observer" @submit.prevent="finalizarPasoUno()">
                            <div v-for="(comprador, index) in datos_compradores" :key="index">
                                <DatosAbonoComponent 
                                    :abono="comprador" 
                                    :index="index + 1" 
                                    :desactivar="desactivar"
                                    :validator="$refs.observer"
                                    :error_telefono="error_telefono"
                                    v-model="datos_compradores[index]"
                                    @eliminarAbono="eliminarAbono"
                                />
                            </div>
                            <div class="mt-4 form-button-responsive">
                                <button id="continuar" type="submit" class="button effect-button large-button pb-3" :disabled="desactivar"><span>{{ $t('nuevo_abono.continuar_compra') }}</span></button>
                                <button id="add-abono" type="button" class="button effect-button large-button pb-3 ml-2" @click="addAbono" :disabled="desactivar || datos_compradores.length >= 6"><span>{{ $t('nuevo_abono.add_abono', { abono: teatro.texto_abono }) }}</span></button>
                            </div>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </section>
    </transition>
</template>

<script>
import DatosAbonoComponent from '@/components/frontend/abonos/lfp/nuevo/DatosAbonoComponent'

export default {
    props: {
        desactivar: {
            type: Boolean,
            required: true
        },
        datos_compradores: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            error_telefono: 0
        }
    },
    methods: {
        eliminarAbono(index) {
            this.datos_compradores.splice(index - 1, 1);
        },
        addAbono() {
            if (this.datos_compradores.length < 6) {
                this.datos_compradores.push(this.createEmptyComprador());
            }
        },
        createEmptyComprador() {
            this.error_telefono = 0;
            return {};
        },
        async finalizarPasoUno() {
            const isValid = await this.$refs.observer.validate();
            const tienen_telefono = this.datos_compradores.filter(datos_comprador => !isNaN(datos_comprador.telefono) && datos_comprador.telefono != null && datos_comprador.telefono_valido).length === this.datos_compradores.length;

            if (isValid && tienen_telefono) {
                this.error_telefono = 0;
                this.guardarDatos();
            } else {
                this.error_telefono += 1;
            }
        },
        guardarDatos() {
            const params = {
                filters: {},
                datos_compradores: this.datos_compradores,
                tid: this.configuracion.hash_teatro
            }

            this.$store.dispatch(this.config.getVuexAlias('front.abonados.lfp.guardar-datos'), params).then(res => {
                this.$toast.success(res.data.message);
                this.$emit('rellenarDatos', this.datos_compradores, res.data.session_id);
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        }
    },
    computed: {
        teatro(){
            return this.$store.getters.getTeatro;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    components: {
        DatosAbonoComponent
    }
}
</script>